import { useEffect, useState } from "react";

const fums3Enabled = process.env.REACT_APP_FUMS_V3_ENABLED === "true";

// useFums is a React Hooks that can be used to "watch" the current fumsTokens visible
// on the screen a component just needs to give a fumsToken or array of fumsTokens and
// useFums will make sure only to report views when it's needed.

// The logic is as follows:
// [] || ""                           : nothing showing, report nothing
// [fums-id-1]                        : fums-id-1 shown, fums-id-1 reported
// [fums-id-1, fums-id-2, fums-id-3]  : two parallels added, only report fums-id-2 & fums-id-3
// [fums-id-2, fums-id-3]             : report nothing
// [fums-id-1]                        : report fums-id-1

export function useFums(fumsTokens: string | string[]) {
  const [prevFumsIds, setPrevFumsIds] = useState<string[]>([]);

  const deduppedFumsIds =
    typeof fumsTokens === "string" ? [fumsTokens] : [...new Set(fumsTokens)].sort();
  const deduppedFumsIdsString = deduppedFumsIds.join(",");
  const newFumsIds = deduppedFumsIds.filter(id => !prevFumsIds.includes(id));
  const newFumsIdsString = newFumsIds.join(",");

  useEffect(() => {
    if (!fums3Enabled) return;

    const recievedFumsIds = deduppedFumsIdsString.split(",");
    setPrevFumsIds(recievedFumsIds);

    if (!newFumsIdsString) return;

    const fumsTokens = newFumsIdsString.split(",");
    (window as any).fums('trackView', fumsTokens);
  }, [newFumsIdsString, deduppedFumsIdsString]);
}
